import _ from 'lodash'
import { useSnackbar } from 'notistack'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

import { useSendExpertiseMutation } from '@/core/services/expertise'
import { getApiErrorMessage } from '@/utils/errors'

const schema = z.object({
  doctorId: z.string().min(1),
})

export type SelectDoctorFormData = z.infer<typeof schema>

export function useSelectDoctorForm(expertiseId: string) {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [sendExpertise, { isLoading: isSendingExpertise }] = useSendExpertiseMutation()

  const rhForm = useForm<SelectDoctorFormData>({
    defaultValues: { doctorId: '' },
    resolver: zodResolver(schema),
  })

  const onSubmit: SubmitHandler<SelectDoctorFormData> = async (data) => {
    try {
      const expertise = await sendExpertise({ id: expertiseId, receiverId: data.doctorId, receiverType: 'Staff' }).unwrap()
      const doctor = _.trim(`${expertise.medecin?.userInfo.name || ''} ${expertise.medecin?.userInfo.surname || ''}`)
      enqueueSnackbar(t('notification.expertise.send.successToDoctor', { doctor }), {
        variant: 'success',
      })
      navigate('/expertises')
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, t('notification.expertise.send.error')), { variant: 'error' })
    }
  }

  return { isSendingExpertise, rhForm, onSubmit }
}
